import React from 'react';
import {toAbsoluteUrl} from '@/utils';
import {Link} from "react-router-dom";

interface NoCandidatesContentProps {
    onAddNewCandidate?: () => void;
}

const NoCandidatesContent: React.FC<NoCandidatesContentProps> = ({onAddNewCandidate}) => {
    return (
        <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
            <div className="lg:col-span-3">
                <div className="mb-7.5">
                    <div className="card">
                        <div className="card-body px-10 py-7.5 lg:pr-12.5 flex flex-col justify-start">
                            <div className="flex flex-wrap md:flex-nowrap items-start gap-6 md:gap-10">
                                <div className="flex flex-col gap-3">
                                    <h1 className="text-2xl font-semibold text-gray-900">
                                        Start by adding your first candidate!
                                    </h1>
                                    <h2 className="text-1xl font-semibold text-gray-900">
                                        Create a candidate profile to enhance your hiring process.
                                    </h2>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        To begin, add a candidate profile – the first step towards building
                                        a strong talent pool.
                                        Once you've added a candidate, you'll be able to match them to suitable
                                        jobs, assess their fit, and streamline your recruitment process.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Adding a candidate is quick and easy: fill in details from a URL,
                                        upload a resume, or simply copy and paste the relevant information.
                                        After that, you’ll be ready to evaluate and engage with potential hires
                                        confidently and efficiently.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Don’t worry – UPFLINX Buddy makes everything simple and intuitive,
                                        even if you’re new to AI-driven hiring tools.
                                    </p>
                                </div>
                                <img
                                    src={toAbsoluteUrl('/media/images/avatar-high.png')}
                                    className="dark:hidden max-h-[250px]"
                                    alt="Add Candidate Illustration"
                                />
                            </div>
                        </div>
                        <div className="card-footer justify-center">
                            <button
                                onClick={onAddNewCandidate}
                                className="btn btn-link"
                                role="button"
                            >
                                Add your first candidate now!
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export {NoCandidatesContent};
